/**
 * Server state for billing. Paying happens on pages Stripe hosts, so the two writes here only ask
 * the API for such a page and send the browser there; what changed comes back through Stripe's
 * webhook, and the billing query shows it once the browser returns.
 */

import { queryOptions, useMutation } from "@tanstack/react-query";
import { api } from "@/api/client";
import { unwrap } from "@/api/problem";
import type { components } from "@/api/schema";

export type Billing = components["schemas"]["SubscriptionOut"];
export type PlanOffer = components["schemas"]["PlanOut"];

export const billingQuery = queryOptions({
  queryKey: ["billing"],
  queryFn: async () => unwrap(await api.GET("/api/v1/billing/subscription")),
});

/** Leave for a Stripe page. `assign` rather than `replace`, so Back returns here. */
function go(url: string) {
  window.location.assign(url);
}

export function useCheckout() {
  return useMutation({
    mutationFn: async (planCode: string) =>
      unwrap(await api.POST("/api/v1/billing/checkout", { body: { plan_code: planCode } })),
    onSuccess: ({ url }) => go(url),
  });
}

export function usePortal() {
  return useMutation({
    mutationFn: async () => unwrap(await api.POST("/api/v1/billing/portal")),
    onSuccess: ({ url }) => go(url),
  });
}
